import { createContext } from 'react';
import { useAuth } from '../hooks/useAuth';

export const AuthContext = createContext();

export function AuthProvider({ children }) {
    const { userId, loginUser, token, login, logout } = useAuth();
    const value = { userId, loginUser, token, login, logout };

    return (
        <AuthContext.Provider value={value}>
            {children}
        </AuthContext.Provider>
    )
}